import { render, staticRenderFns } from "./StatusReportSection.vue?vue&type=template&id=c0f7584c&scoped=true"
import script from "./StatusReportSection.vue?vue&type=script&lang=ts"
export * from "./StatusReportSection.vue?vue&type=script&lang=ts"
import style0 from "./StatusReportSection.vue?vue&type=style&index=0&id=c0f7584c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7584c",
  null
  
)

export default component.exports